import { action } from 'typesafe-actions';
import { IResetPasswordActionTypes } from './Types';

export const sendResetPasswordEmail = (email: string, username: string) =>
	action(IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL, [
		email,
		username,
	]);
export const sendResetPasswordEmailSucceed = () =>
	action(IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL_SUCCEED);
export const sendResetPasswordEmailFailed = (err: string) =>
	action(IResetPasswordActionTypes.SEND_RESET_PASSWORD_EMAIL_FAILED, err);
export const recoverUsernameFromEmailAdress = (email: string) =>
	action(IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL, email);
export const recoverUsernameFromEmailAdressSucceed = () =>
	action(IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL_SUCCEED);
export const recoverUsernameFromEmailAdressFailed = (err: string) =>
	action(IResetPasswordActionTypes.RECOVER_USERNAME_FROM_EMAIL_FAILED, err);
export const recoveredMultipleUsername = () =>
	action(IResetPasswordActionTypes.RECOVERED_MULTIPLE_USERNAME);
export const recoveredSingleUsername = (username: string) =>
	action(IResetPasswordActionTypes.RECOVERED_SINGLE_USERNAME, username);
